import ButtonBase from 'components/partials/button'
import DropdownBase, { Option } from 'components/partials/dropDown'
import InputBase from 'components/partials/inputBase'
import { AGENCY_GROUP } from 'constants/common'
import { onHandleCopyItem } from 'helpers/functionUtils'
// import TestSendEmailDocumentDialog from 'pages/agency-group-management/forward-email/components/send-test-email-document-dialog'
import { IHtmlTemplate } from 'pages/agency-group-management/interface'
import PreviewDialog from 'pages/agency-group-management/template-customization/components/previewDialog'
import UploadHTMLAndCSSFile from 'pages/agency-group-management/template-customization/components/uploadFile'
import React, { useEffect, useState } from 'react'

interface Props {
  htmlTemplate: IHtmlTemplate
  isEditMode: boolean
  sendingEmailSubject: string
  onChange: (htmlTemplate: IHtmlTemplate) => void
  clearErrorTemplate: () => void
}

const TYPE_OPTIONS: Option[] = Object.values(AGENCY_GROUP.EMAIL_TEMPLATE_TYPE).map((item) => ({
  id: item,
  name: item,
}))

const EmailTemplate: React.FC<Props> = ({
  htmlTemplate,
  isEditMode,
  sendingEmailSubject,
  onChange,
  clearErrorTemplate
}) => {
  const [isOpenPreviewDialog, setIsOpenPreviewDialog] = useState(false)
  // const [isOpenTestSendDocument, setIsOpenTestSendDocument] = useState(false)
  const [templateTypeSelected, setTemplateTypeSelected] = useState(
    AGENCY_GROUP.EMAIL_TEMPLATE_TYPE.DOCUMENT_URL,
  )

  useEffect(() => {
    if (htmlTemplate.templateType) {
      setTemplateTypeSelected(htmlTemplate.templateType)
    }
  }, [htmlTemplate])

  const handleStoreHtmlTemplateString = (htmlString: string) => {
    onChange({ htmlString, templateType: templateTypeSelected, documentURL: '' })
  }

  // const onClickDownloadExampleBtn = () => {
  //   alert('alo')
  // }

  const onChangeTemplateType = (option: Option) => {
    if (option.name && templateTypeSelected !== option.name) {
      setTemplateTypeSelected(option.name)
      clearErrorTemplate()
    }
  }

  const onClickPreviewBtn = () => {
    setIsOpenPreviewDialog(true)
  }

  const onChangeDocumentURLInput = (val: string) => {
    onChange({ documentURL: val, htmlString: '', templateType: templateTypeSelected })
  }

  const onClickCopyBtn = async () => {
    const value = htmlTemplate.documentURL
    await onHandleCopyItem(value, 'Copied', 'Something wrong')
  }

  // const onClickTestSendBtn = () => {
  //   setIsOpenTestSendDocument(true)
  // }

  return (
    <div className="flex flex-col">
      {/* <div className="pb-2">
        <ButtonBase onClick={onClickDownloadExampleBtn}>Download Example</ButtonBase>
      </div> */}

      <div className="flex space-x-2">
        <DropdownBase
          className={`min-w-[20%] ${!isEditMode ? 'bg-gray-100' : ''}`}
          options={TYPE_OPTIONS}
          initialValue={templateTypeSelected}
          isDisabled={!isEditMode}
          handleOptions={onChangeTemplateType}
        />
        {isEditMode ? (
          templateTypeSelected === AGENCY_GROUP.EMAIL_TEMPLATE_TYPE.HTML_CSS ? (
            <UploadHTMLAndCSSFile
              htmlString={htmlTemplate.htmlString}
              sendingEmailSubject={sendingEmailSubject}
              handleStoreHtmlTemplateString={handleStoreHtmlTemplateString}
            />
          ) : (
            <div className="flex w-full space-x-2">
              <InputBase
                className="w-full"
                handleChange={onChangeDocumentURLInput}
                value={htmlTemplate.documentURL}
              />
              {/* <ButtonBase onClick={onClickTestSendBtn}>Test</ButtonBase> */}
            </div>
          )
        ) : (
          <div className="flex w-full space-x-2">
            <InputBase
              className="w-full bg-gray-100"
              value={
                htmlTemplate.templateType === AGENCY_GROUP.EMAIL_TEMPLATE_TYPE.HTML_CSS
                  ? htmlTemplate.htmlString
                  : htmlTemplate.documentURL
              }
              disable={true}
            />
            {htmlTemplate.templateType === AGENCY_GROUP.EMAIL_TEMPLATE_TYPE.HTML_CSS ? (
              <ButtonBase className="min-w-[120px]" onClick={onClickPreviewBtn}>
                Preview
              </ButtonBase>
            ) : (
              <ButtonBase className="min-w-[120px]" onClick={onClickCopyBtn}>
                Copy
              </ButtonBase>
            )}
          </div>
        )}
      </div>

      {isOpenPreviewDialog && (
        <PreviewDialog
          handleClosePreviewDialog={() => {
            setIsOpenPreviewDialog(false)
          }}
          htmlString={htmlTemplate.htmlString}
          isLoadingData={false}
          isOpenPreview={isOpenPreviewDialog}
          sendingEmailSubject={sendingEmailSubject}
        />
      )}

      {/* {isOpenTestSendDocument && (
        <TestSendEmailDocumentDialog
          documentURL={htmlTemplate.documentURL}
          handleClosePreviewDialog={() => {
            setIsOpenTestSendDocument(false)
          }}
          isOpenPreview={isOpenTestSendDocument}
        />
      )} */}
    </div>
  )
}

export default EmailTemplate
